import { useQuery } from 'react-query';
import UserService from '../../../services/UserService';
import { ORGANIZATION } from '../../constants/queryDefinition';

export default function useDealerDetails(params) {
  const userService = UserService.get();

  async function getDealerDetails({ queryKey }) {
    const [, dealerDetailsParams] = queryKey;
    const tradeMetaDataResponse = await userService.getDealerDetails({
      ...dealerDetailsParams
    });

    return tradeMetaDataResponse;
  }

  const dealerDetails = useQuery(
    [ORGANIZATION.GETDEALER.KEY, params],
    getDealerDetails,
    {
      enabled: !!params?.companyId
    }
  );

  return dealerDetails;
}
